import { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { axiosPost } from "../../utils/AxiosHelper";
import ESStatisticsCard from "../../controls/ESStatisticsCard";
import { FaUsers } from "react-icons/fa";
import { getDashboardStatisticsCount } from "../../utils/ApiUrl";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../routes/routes";
import { checkIfSuperAdmin, fetchOrganization } from "../../utils/common";

interface StatisticsInfo {
  Title: string;
  Count: number;
}

interface PropsType {}

const colorClasses = [
  "dark-blue",
  "medium-Orange",
   "light-green",
   "lime-green",
  "magenta",
  "dark-green",
  "dark-brown"
];

export default function Statistics(props: PropsType) {
  const { appContextdata, setAppContextdata } = useContext<any>(UserContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  

  const [statisticsInfo, setStatisticsInfo] = useState<StatisticsInfo[]>([]);

  useEffect(() => {
    fetchDashboardStatisticsInfo();
  }, []);

  const fetchDashboardStatisticsInfo = async () => {
    setLoading(true);
    setError(null);
    try {
      const response: any = await axiosPost(getDashboardStatisticsCount, {
        OrganizationId: appContextdata?.Organization || 0,
      });
      const data = response.data.ExtraData || [];
      setStatisticsInfo(data);
    } catch (error) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

   const fetchData = async () => {
     if (appContextdata?.Role) {
       const isAdmin = checkIfSuperAdmin(appContextdata);
       if (isAdmin) {
         setIsSuperAdmin(true);         
       }
     }
   };
   useEffect(() => {
     fetchData();
   }, [appContextdata?.Role]);

  const MappingStatisticsCard = (data: StatisticsInfo[]) => {
    return (
      data !== null &&
      data?.length > 0 &&
      data?.map((item: StatisticsInfo, index: number) => {
        const colorIndex = index % colorClasses?.length;

       
        if (
          item?.Title !== "Organizations" ||
          (item?.Title === "Organizations" && isSuperAdmin)
        ) {
          return (
            <Col key={index} lg="3" md="6" xs="12">
              <ESStatisticsCard
                title={item?.Title}
                icon={<FaUsers />}
                colorIndex={colorIndex}
                count={item.Count}
              />
            </Col>
          );
        }
        return null; 
      })
    );
  };


  return (
    <>
      <div className="statistic-cards">
        <Row>{MappingStatisticsCard(statisticsInfo)}</Row>
      </div>
    </>
  );
}
